import { SidebarModule } from '@/config/permissions'
import { useModuleAccess } from '@/hooks/use-module-access'
import { Main } from '@/components/layout/main'
import { AttendantsDialogs } from './components/attendants-dialogs'
import { AttendantsPrimaryButtons } from './components/attendants-primary-buttons'
import { AttendantsDataTable } from './components/data-table'
import { AttendantsProvider } from './context'

export default function Attendants() {
  useModuleAccess(SidebarModule.ATTENDANTS)
  return (
    <AttendantsProvider>
      <Main>
        <div className='flex flex-wrap items-center justify-between mb-2 space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Atendentes</h2>
            <p className='text-muted-foreground'>
              Aqui você gerencia os atendentes do seu time.
            </p>
          </div>
          <AttendantsPrimaryButtons />
        </div>
        <div className='flex-1 px-4 py-1 -mx-4 overflow-auto lg:flex-row lg:space-x-12 lg:space-y-0'>
          <AttendantsDataTable />
        </div>
      </Main>

      <AttendantsDialogs />
    </AttendantsProvider>
  )
}
